import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';

@Component({
  selector: 'app-conversation-edit',
  templateUrl: './conversation-edit.component.html',
  styleUrls: ['./conversation-edit.component.scss']
})
export class ConversationEditComponent extends DialogBase implements OnInit {

  title: any;
  buttonLabel: any;
  logPartyOptions: any[] = [];
  logParty: any;
  ticketNo: any;
  initialMessage: any;

  detailForm: FormGroup;
  error: any;

  message: any;
  user: any;

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.setFormControls();
    this.user = this.authService.getUser();
  }

  setFormControls() {
    this.detailForm = this.fb.group({
      message: false,
    });
  }

  submit() {
    if (!this.message) {
      return;
    }
    const message = `${ this.message }\n\n[Updated by]\n- Updated By: ${this.user.username}`
    const selectedLogParty = this.logPartyOptions.find(f => f.code === this.logParty)

    const params: any = {
      channel: selectedLogParty.channel,
      to: selectedLogParty.to,
      log: message,
      code: selectedLogParty.code,
    };

    this.spinnerService.start();
    this.apiService.ticket.log(this.ticketNo, params)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.message = null;
        const { logs } = res;
        this.onClose.next(logs);
        this.close();
      }, err => Utils.showError(err));
  }

}
